<template>
  <span>
    {{ name }}:
    <br />
    <input
      :value="value"
      :name="name"
      class="dimension"
      @input="inputHandler"
    />
  </span>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ""
    },
    value: {
      type: Number,
      default: null
    }
  },
  methods: {
    inputHandler(event) {
      const inputValue = Number(event.target.value);

      if (!isNaN(inputValue)) {
        this.$emit("input", inputValue);
      }
    }
  }
};
</script>

<style scoped>
input.dimension {
  display: inline-block !important;
}
</style>
